import React,{useState} from 'react'
import './Smarttask.css'

const Smarttask = ({tab}) => {
    const [active, setActive] = useState('1')

    const handleonClicked = (e) =>{
        setActive(e.target.id)
        tab(e.target.innerHTML)
    }
  return (
    <div className='smartask-main-container'>
        <span>Filter by:</span>
        <span id='1' className={active === '1' ? 'spactive' : ''} onClick={handleonClicked}>All</span>
        <span id='2' className={active === '2' ? 'spactive' : ''} onClick={handleonClicked}>KPI</span>
        <span id='3' className={active === '3' ? 'spactive' : ''} onClick={handleonClicked}>Personal</span>
        <span id='4' className={active === '4' ? 'spactive' : ''} onClick={handleonClicked}>Technical</span>
        <span id='5' className={active === '5' ? 'spactive' : ''} onClick={handleonClicked}>Marketing</span>
        <span id='6' className={active === '6' ? 'spactive' : ''} onClick={handleonClicked}>Sales</span>
        <span id='7' className={active === '7' ? 'spactive' : ''} onClick={handleonClicked}>Helpdesk</span>
    </div>
  )
}

export default Smarttask